module.exports = __webpack_public_path__ + "static/media/Disclaimer_DIY.f6379bff.pdf";